import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-database" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "topbar-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("li", null, [
    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
      to: "/offline",
      class: _normalizeClass(_ctx.networkState === 'online' ? 'text-primary' : 'text-danger')
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_ctx.queueCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.queueCount), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])), [
      [
        _directive_tooltip,
        _ctx.t(`offline.networkStates.${_ctx.networkState}`),
        void 0,
        { bottom: true }
      ]
    ])
  ]))
}